module.exports = __webpack_public_path__ + "img/draw_wheel.1430d292.png";